import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import Modal, { ModalHeader } from '../Modal';
import { alarmSettingPreview, } from '../../utils/AlarmSetting';
import { ControlTable } from '../Table';
import { getNotificationDefaultSettings, updatePushNotiState } from '../../apis/notification';
import { toast } from '../../utils/toast';
import { isEmpty } from '../../utils/lodashExtend';

const PreviewAlarmSetting = () => {
  const { employee, previewAlarmSettings } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
      previewAlarmSettings: store.Employee.previewAlarmSettings,
    }),
    shallowEqual
  );

  const [fields, setFields] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [defaultSettings, setDefaultSettings] = useState(null);

  useEffect(() => {
    getNotificationDefaultSettings()
      .then(res => {
        setDefaultSettings(res);
      });
  }, []);

  useEffect(() => {
    if (employee) {
      const fields = [
        {
          title: "알람",
          key: "label"
        },
        {
          key: "isSubscribed",
          width: '80px',
          type: "switch",
          // onValue: (d) => d ? "처리" : "미처리"
          checked: (d) => d.isSubscribed,
          onChange: (e, data) => {
            setIsLoading(true);
            const settings = [{
              isSubscribed: e.target.checked,
              type: data.value,
            }];

            updatePushNotiState({ settings }).then(res => {
              toast.success("설정이 변경되었습니다.");
              alarmSettingPreview(employee.idx);
            }).finally(() => setIsLoading(false));
          }
        },
      ];

      setFields(fields);

      if (previewAlarmSettings && !isEmpty(defaultSettings)) {
        setList((employee.type > 1 ? defaultSettings.TAX_ALARM_LIST : defaultSettings.BIZ_ALARM_LIST).map(item => {
          const alarmData = previewAlarmSettings.find(f => f.type === item.value);
          return {
            ...item,
            isSubscribed: true,
            ...alarmData,
          };
        }));
      } else {
        setList([]);
      }
    }
  }, [previewAlarmSettings, employee, defaultSettings]);

  const cancel = () => {
    // setOpen(false);
    alarmSettingPreview(null);
  };

  return (
    <>
      <Modal
        size="sm"
        isOpen={!!previewAlarmSettings}
        close={cancel}
      >
        <ModalHeader>알림 설정</ModalHeader>

        <ControlTable
          isHideControlHeader
          isHideHeader
          fields={fields}
          list={list}
          isLoading={isLoading}
        />
      </Modal>
    </>
  );
};

export default PreviewAlarmSetting;